
const HpHistRow = ({hpItem, idx}) => {
    let underlineFirst = idx === 0 ? 'underline' : 'none'
    let afterColor = hpItem.input > -1 ? "#008b00" : "#882e2e"
    // Get the creatures name of the round the damage was done on
    let splits = hpItem?.rt?.split(".")
    let round = splits[0]
    let turn = splits[1]
    
    let sign = hpItem.input >= 0 ? "+" : "-"
    let color = hpItem.input >= 0 ? "#66ae66" : "#ae6666"
    let input = Math.abs(hpItem.input)
    let title = "Heal/Damage"
    if(hpItem.inputType === 'override') {
        sign = '**';
        color = "#000000"
        title = "Max Hp Override"
    } else if(hpItem.inputType === 'temp') {
        sign = '>>';
        color = "#0fafb5"
        title = "Temp Hp Change"
    }

    return (
        <>
            <div className='histItem' style={{cursor: "help"}} title={hpItem.onTurnName ? `Round ${round} - Turn ${turn}: ${hpItem.onTurnName}'s turn` : "No Turn data"}>{hpItem.rt}</div>
            <div className='columnDiv'/>
            <div className='histItem'>
                {hpItem.before}
                {hpItem.beforeTemp !== 0 && <span className="tempHist">+{hpItem.beforeTemp}</span>}
            </div>
            
            <div className='histItem' title={title} style={{color: color, cursor: "help"}}>{sign}</div>
            <div className='histItem' style={{color: color}}>{input}</div>
              
            <div className='histItem'>⇒</div>
            
           
            <div className='histItem' style={{color: afterColor, textDecoration: underlineFirst, fontSize: "1em"}}>
                {hpItem.after}{hpItem.afterTemp !== 0 && <span className="tempHist">+{hpItem.afterTemp}</span>}{hpItem.after < 1 && <>☠️</>}
            </div>
           
            
                {idx === 0 && <>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                    <div className='rowDiv'/>
                </>
            }                        
        </>
    );
}

export default HpHistRow;